import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppLocationService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppLocations`);
    }
}